var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.from)?_c('date-display',{attrs:{"date":_vm.from}}):_vm._e(),(_vm.from && _vm.till)?[_vm._v("\n    -\n  ")]:_vm._e(),(_vm.till)?_c('date-display',{attrs:{"date":_vm.till}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }